import React from "react"
import Text from "src/components/Text"
import { formatNumber } from "src/utils/parseStringToBigNumber"

interface AprRowProps {
  text: string
  apr: number
}

const AprRow = ({ text, apr }: AprRowProps) => {
  return (
    <Text
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      p="12px"
      borderRadius="10px"
      gradient="gradient1"
    >
      {text}
      <Text variant="h5" alignItems="center">
        {apr < 0.001 ? "< 0.1" : formatNumber(apr, 2, 2)}%
      </Text>
    </Text>
  )
}

export default AprRow
